import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  width: "100%",
};

export const adornment: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 18,
  height: 18,
  top: "calc(50% - 9px)",
  insetInlineEnd: 14,
  transition: "transform 0.2s ease",
};
